<template>
  <div>
    <div v-if="!pageLoading">
      <back-nav to="PersonalDetails" />
      <top-card current="PersonalDetails"
        :cover-type="coverType"
        :instalments="installments"
        :premiumAmount = "premiumAmount"
      >
        Kindly provide some additional details before you proceed
      </top-card>
      <v-card class="tw-mt-5 md:tw-mt-16">
        <div class="tw-px-4 md:tw-px-8">
          <card-title icon="mdi-account">Personal Details</card-title>
        </div>
        <div class="tw-px-4 md:tw-px-12 tw-mt-4 md:tw-mt-10">
          <v-form v-model="isValid">
            <div class=" tw-grid tw-grid-cols-1 md:tw-grid-cols-2">
              <v-text-field
                  v-model="form.fullName"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Full Name"
                  type="text"
                  :rules="[required('Full Name')]"
              ></v-text-field>
              <v-text-field
                  v-model="form.mobileNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Mobile No."
                  type="text"
                  :rules="[required('Mobile No.'), mobileFormat()]"
              ></v-text-field>
              <v-text-field
                  v-model="form.email"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="Email"
                  type="text"
                  :rules="[required('Email'), emailFormat()]"
              ></v-text-field>
              <v-text-field
                  v-model="form.idNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="ID No."
                  type="number"
                  :rules="[required('ID No.'), minLength('ID No.',6), maxLength('IS NO.', 8)]"
              ></v-text-field>
              <v-text-field
                  v-model="form.poBoxNo"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="PO Box No."
                  type="number"
                  :rules="[required('PO Box No.')]"
              ></v-text-field>
              <v-autocomplete
                  v-model="form.postalCode"
                  :loading="postCodeLoading"
                  :items="postCodeItems"
                  :search-input.sync="postCodeSearch"
                  class="my-2 tw-px-0 md:tw-px-6"
                  hide-no-data
                  hide-details
                  label="Postal Code"
                  :rules="[required('Postal Code')]"
              ></v-autocomplete>
              <v-text-field
                  v-model="form.kraPinNumber"
                  class="my-2 tw-px-0 md:tw-px-6"
                  label="KRA PIN"
                  type="text"
                  :rules="[required('KRA PIN'), kraPinFormat()]"
              ></v-text-field>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                  v-model="computedDateOfBirth"
                    class="my-2 tw-px-0 md:tw-px-6"
                    label="Date Of Birth"
                    :rules="[required('Date of Birth')]"
                    v-on="on"
                    v-bind="attrs"
                  ></v-text-field>
                 </template>
                 <v-date-picker
                   v-model="dateOfBirth"
                   :max="new Date().toISOString().substr(0, 10)"
                   min="1950-01-01"
                  ></v-date-picker>
                </v-menu>
              <v-radio-group v-model="form.gender" class="my-2 tw-px-0 md:tw-px-6" :rules="[required('Gender')]"  row>
                <v-radio label="Male" value="MALE" class="tw-mt-0 md:tw-mt-5 tw-pr-10"></v-radio>
                <v-radio label="Female" value="FEMALE" class="tw-mt-0 md:tw-mt-5"></v-radio>
              </v-radio-group>
            </div>

            <div class="tw-w-full">
              <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Preferred policy start date.</h3>
              <hr class="tw-mt-3 tw-mb-5">
            </div>

            <div class=" tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-mt-4 md:tw-mt-10">
              <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="computedDateFormatted"
                      label="Start Date"
                      persistent-hint
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="[required('Start Date')]"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" :min="new Date().toISOString().substr(0, 10)" no-title @input="menu = false" color="primary"></v-date-picker>
              </v-menu>
            </div>

            <div v-if="coverType.covertypeId === 120 && 'additionalBenefits' in this.coverType && beneficiaries.length > 0">
              <div class="tw-w-full">
                <h3 class="c-blue-text c-title tw-text-base md:tw-text-lg tw-px-2 md:tw-px-8 tw-mt-3 md:tw-mt-10">Add Beneficiary details for travel embedded</h3>
                <hr class="tw-mt-3 tw-mb-5">
              </div>

              <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-3 tw-mt-4 md:tw-mt-10">
                <v-card v-for="(beneficiary, counter) in beneficiaries" :key="counter" class="tw-w-64 tw-my-4 mx-auto tw-p-3" outlined>
                  <div class="tw-w-full tw-flex tw-justify-end tw-absolute tw--ml-4 tw--mt-2">
                    <v-icon :id="'deleteBeneficiary-' + counter" class="tw-bg-red-700 tw-rounded-full tw-p-1 tw-cursor-pointer" title="remove beneficiary" size="17" color="#fff" @click="deleteBeneficiaries(counter)">mdi-close</v-icon>
                  </div>
                  <div>
                    <h5 class="c-blue-text c-title tw-text-sm">Beneficiary {{ counter+1 }}</h5>
                  </div>
                  <v-text-field v-model="beneficiary.fullName" label="Full Name" class="my-2" :rules="[required('Full Name')]"></v-text-field>
                  <v-text-field v-model="beneficiary.passportNumber" label="Passport No." class="my-2" :rules="[required('Passport No.')]"></v-text-field>
                  <v-select v-model="beneficiary.relationship" :items="relationship" label="Relationship" class="my-2" :rules="[required('Relationship')]"></v-select>
                  <v-menu
                      v-model="beneficiary.menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                          v-model="beneficiary.dateOfBirth"
                          label="Date of Birth"
                          persistent-hint
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :rules="[required('Date Of Birth')]"
                      ></v-text-field>
                    </template>
                    <v-date-picker :ref="'picker_'+counter" v-model="beneficiary.date" no-title @input="beneficiary.menu = false" :max="new Date().toISOString().substr(0, 10)" min="1950-01-01" color="primary"></v-date-picker>
                  </v-menu>
                </v-card>
              </div>
            </div>

            <v-card-actions class="col-sm-4 offset-sm-4 tw-mt-5 tw-pb-8">
              <v-btn block large
                     color="secondary"
                     class="my-3 "
                     :loading="loading"
                     @click="proceed"
                     :disabled="!isValid"
              >
                {{ isValid ? 'Continue' : 'Check if all fields are filled' }}
              </v-btn>
            </v-card-actions>

          </v-form>
        </div>
      </v-card>
    </div>
    <div v-else class="tw-w-full tw-flex tw-justify-center">
      <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-nested-ternary,no-unused-expressions */

import CardTitle from '@/components/shared/CardTitle';
import TopCard from '@/components/buy/TopCard';
import { formatDate, formatDate2, changeFormat } from '@/utils/time';
import BackNav from '@/components/buy/BackNav';
import { mapGetters } from 'vuex';
import validations from '@/utils/validations';
import axios from 'axios';
import postalCodes from '@/utils/postalCodes.json';
import { FB_BUY_PERSONAL } from '@/utils/const';

export default {
  name: 'PersonalDetails',
  components: { BackNav, TopCard, CardTitle },
  data: () => ({
    date: '',
    dateOfBirth: '',
    menu: false,
    loading: false,
    isValid: false,
    relationship: ['FATHER', 'MOTHER', 'SPOUSE', 'CHILD'],
    beneficiaries: [],
    benefit: '',
    menu1: false,
    form: {},
    pageLoading: true,
    ...validations,
    postCodeLoading: false,
    postCodeItems: [],
    postCodeSearch: null,
    quote: null,
  }),
  computed: {
    ...mapGetters('rfq', ['getQoute']),
    ...mapGetters('auth', ['isAuthenticated', 'authenticatedUser']),
    coverType() {
      return this.getQoute.covertypes.find((e) => e.riskId === this.benefit);
    },
    installments() {
      return this.getQoute.instalments;
    },
    premiumAmount() {
      return this.installments?.reduce((sum, installment) => sum + installment.premium, 0);
    },
    computedDateFormatted() {
      return this.form.coverFrom || this.formatDate(this.date);
    },
    computedDateOfBirth() {
      return this.formatDate(this.dateOfBirth);
    },
    client() {
      return this.getQoute.client || {};
    },
  },
  watch: {
    postCodeSearch(val) {
      val && val !== this.form.postalCode && this.postCodeFilter(val);
    },
    // eslint-disable-next-line no-unused-vars
    date(val) {
      this.form.coverFrom = this.formatDate(this.date);
    },
    dateOfBirth() {
      this.form.dateOfBirth = this.formatDate(this.dateOfBirth);
    },
    beneficiaries: {
      deep: true,
      handler(val) {
        val.forEach((v, i) => {
          if (v.menu === true) {
            // eslint-disable-next-line no-unused-expressions,no-return-assign
            v && setTimeout(() => (this.$refs[`picker_${i}`][0].activePicker = 'YEAR'));
          }
        });

        val.map((v) => {
          if (v.date !== '') {
            // eslint-disable-next-line no-param-reassign
            v.dateOfBirth = this.formatDate(v.date);
          }
          return v;
        });
      },
    },
  },
  metaInfo: {
    title: 'Buy - Personal Details',
  },
  mounted() {
    const quote = this.$route.query.q;
    const benefit = this.$route.query.b;
    if (quote && benefit) {
      this.benefit = parseInt(benefit, 10);
      this.fetchQuotation(quote);
    }
  },
  methods: {
    async proceed() {
      this.loading = true;
      if (this.beneficiaries.length > 0) {
        const requestBenefits = [];
        this.beneficiaries.forEach((b) => {
          requestBenefits.push({
            fullName: b.fullName, passportNumber: b.passportNumber, dateOfBirth: b.dateOfBirth, relationship: b.relationship.toUpperCase(),
          });
        });
        const benefitData = {
          beneficiaries: requestBenefits,
          selectedRiskId: this.benefit,
        };
        await axios.put('/customer/quotation/beneficiary/change', benefitData)
          // eslint-disable-next-line no-unused-vars
          .then((_response) => {
            this.$toast.success('Beneficiries Successfully added', 'Beneficiaries');
          });
      }
      await axios.put('/customer/quotation/update', this.$data.form)
        // eslint-disable-next-line no-unused-vars
        .then((response) => {
          this.$toast.success('Personal Details confirmed successfully', 'Details');
          this.loading = false;
          this.$analytics.logEvent(FB_BUY_PERSONAL);
          this.$emit('to-car-details');
        });
    },
    formatDate,
    formatDate2,
    changeFormat,
    deleteBeneficiaries(counter) {
      this.beneficiaries.splice(counter, 1);
    },
    postCodeFilter(v) {
      this.postCodeLoading = true;
      setTimeout(() => {
        this.postCodeItems = postalCodes.filter((e) => (e || '').toUpperCase().indexOf((v || '').toUpperCase()) > -1);
        this.postCodeLoading = false;
      }, 500);
    },
    async fetchQuotation(quote) {
      await this.$store.dispatch('rfq/getQuotation', quote);
      this.initializeForm();
      this.pageLoading = false;
      this.$root.$emit('qoute-loaded');
    },
    initializeForm() {
      this.bankNameItems = [this.client.bankName || ''];
      this.bankBranchItems = [this.client.bankBranch || ''];

      this.form = this.assignForm();
      this.form.addressLine1 = '1245';
      this.form.documents = [];
      this.form.bankAccount = this.client.bankAccount || '';
      this.form.bankBranch = this.client.bankBranch || '';
      this.form.bankName = this.client.bankName || '';

      this.postCodeItems = [this.client.postalCode || ''];

      if (this.coverType.covertypeId === 120 && 'additionalBenefits' in this.coverType) {
        this.initializeBeneficiaries();
      }
    },
    assignForm() {
      return {
        carDTOS: [this.coverType?.car],
        coverFrom: this.getQoute.coverFrom ? this.changeFormat(this.getQoute.coverFrom) : '',
        dob: this.getQoute.dateOfBirth ? this.changeFormat(this.getQoute.dateOfBirth) : '',
        email: this.client.email || this.isAuthenticated ? this.authenticatedUser.email : '',
        fullName: this.client.fullName || this.isAuthenticated ? this.authenticatedUser.name : '',
        idNumber: this.client.idNumber || '',
        kraPinNumber: this.client.kraPinNumber || this.isAuthenticated ? this.authenticatedUser['custom:kra-pin'] : '',
        mobileNumber: this.client.mobileNumber || this.isAuthenticated ? this.authenticatedUser.phone_number : '',
        pinNumber: this.isAuthenticated ? this.authenticatedUser['custom:kra-pin'] : '',
        poBoxNo: this.client.poBoxNo || '',
        postalCode: this.client.postalCode || '',
        prodId: this.coverType?.productCode,
        quoteId: parseInt(this.$route.query.q, 10),
        selectedRiskId: parseInt(this.$route.query.b, 10),
        stepCode: 'PROVIDE_DETAILS',
        gender: this.client.gender || '',
      };
    },
    initializeBeneficiaries() {
      const travelEmbed = this.coverType.additionalBenefits?.find((e) => e.id === 234);
      const noOfBeneficiaries = travelEmbed ? parseInt(travelEmbed.noOfBeneficiaries, 10) : 0;

      if ('beneficiaries' in this.coverType) {
        this.coverType.beneficiaries.forEach((b) => {
          this.beneficiaries.push({
            fullName: b.fullName,
            passportNumber: b.passportNumber,
            dateOfBirth: b.dateOfBirth,
            relationship: b.relationship,
            menu: false,
            date: '',
          });
        });
      } else {
        for (let i = 0; i < noOfBeneficiaries; i += 1) {
          this.beneficiaries.push({
            fullName: '',
            passportNumber: '',
            dateOfBirth: '',
            relationship: '',
            menu: false,
            date: '',
          });
        }
      }
    },
  },
};
</script>
